import { render, staticRenderFns } from "./sale-order-detail.vue?vue&type=template&id=5aa9d107&scoped=true&"
import script from "./sale-order-detail.vue?vue&type=script&lang=js&"
export * from "./sale-order-detail.vue?vue&type=script&lang=js&"
import style0 from "./sale-order-detail.vue?vue&type=style&index=0&id=5aa9d107&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa9d107",
  null
  
)

export default component.exports